export default __webpack_public_path__ + "static/media/ag-girl.5993a3dd.webp";